import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL, DASHBOARD_URL, readApiResponse } from '../services/authApi';
import { pageStyle, cardStyle, brandStyle, titleStyle, textStyle, labelStyle, inputStyle, buttonStyle, secondaryButtonStyle, errorStyle, successStyle, helperLinkStyle } from './components/authPageStyles';

function RecuperarSenha() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!/\S+@\S+\.\S+/.test(email)) return setError('Informe um e-mail válido.');

    setIsSubmitting(true);
    try {
      await fetch(`${API_BASE_URL}/api/auth/password/forgot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      }).then(readApiResponse);
      setSuccess('Se o e-mail estiver cadastrado, uma senha temporária será enviada. Após entrar, será necessário trocar a senha.');
      setEmail('');
    } catch (err) {
      setError(err.message || 'Não foi possível solicitar a recuperação de senha.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main style={pageStyle}>
      <section style={cardStyle}>
        <div style={brandStyle}>RE</div>
        <h1 style={titleStyle}>Recuperar senha</h1>
        <p style={textStyle}>Informe o e-mail cadastrado no painel. Enviaremos uma senha temporária para você acessar e trocar a senha.</p>
        {error && <div style={errorStyle}>{error}</div>}
        {success && <div style={successStyle}>{success}</div>}
        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>E-mail cadastrado</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seuemail@realenergy.com.br" style={inputStyle} autoComplete="email" />
          <button type="submit" disabled={isSubmitting} style={{ ...buttonStyle, opacity: isSubmitting ? 0.7 : 1 }}>{isSubmitting ? 'Enviando...' : 'Enviar senha temporária'}</button>
        </form>
        <div style={{ display: 'grid', gap: '12px', marginTop: '18px' }}>
          <Link to="/trocar-senha" style={secondaryButtonStyle}>Já tenho senha temporária</Link>
          <a href={DASHBOARD_URL} style={helperLinkStyle}>Voltar para o dashboard</a>
          <Link to="/" style={helperLinkStyle}>Voltar para o site</Link>
        </div>
      </section>
    </main>
  );
}

export default RecuperarSenha;
